import type { BdUiProgressStep } from '@bindoc-projects/ui-lib/feedback/ui';

/** Where the processing of the selected file stands. */
export type KostDataImportDatasetStatus =
  'idle' | 'running' | 'done' | 'failed';

export interface KostDataImportDatasetStepState {
  /** Index of the step reported last; `-1` before the first. */
  index: number;
  /** That step's own percentage; `null` → indeterminate. */
  percent: number | null;
  /** Latest log line of that step, shown after its label. */
  detail?: string;
}

/**
 * Maps the processor's steps onto `bd-ui-step-progress`: steps before the
 * reported one done, the reported one running (or failed), the rest waiting.
 * Before the processor reports a step the first one runs — the AT/CH readers
 * only report at step boundaries.
 */
export function datasetSteps(
  labels: readonly string[],
  state: KostDataImportDatasetStepState,
  status: Exclude<KostDataImportDatasetStatus, 'idle'>,
): BdUiProgressStep[] {
  const current = Math.max(state.index, 0);

  return labels.map((label, index): BdUiProgressStep => {
    if (status === 'done' || index < current) {
      return { label, state: 'done' };
    }
    if (index > current) {
      return { label, state: 'waiting' };
    }
    return status === 'failed'
      ? { label, state: 'failed', detail: state.detail }
      : {
          label,
          state: 'running',
          percent: state.percent,
          detail: state.detail,
        };
  });
}
